import { z } from 'zod';

export type UserCreateForm = {
    dealer_id?: number,
    email: string,
    last_name: string,
    first_name: string,
    second_name: string,
    password: string,
    password_confirmation: string,
    is_admin: 0 | 1,
    position: string,
    phone: string,
};

export type UserCreateFormErrors = {
    dealer_id?: string[],
    email?: string[],
    last_name?: string[],
    first_name?: string[],
    second_name?: string[],
    password?: string[],
    is_admin?: string[],
    position?: string[],
    phone?: string[],
};

export const UserCreateFormErrorsSchema = z.object({
    dealer_id: z.array(z.string()).optional(),
    email: z.array(z.string()).optional(),
    last_name: z.array(z.string()).optional(),
    first_name: z.array(z.string()).optional(),
    second_name: z.array(z.string()).optional(),
    password: z.array(z.string()).optional(),
    is_admin: z.array(z.string()).optional(),
    position: z.array(z.string()).optional(),
    phone: z.array(z.string()).optional(),
});
